const getProgressBarBackground = (
  elapsedTimePercent: number,
  color?: string,
  backgroundColor = 'var(--color-input-background)',
) => {
  const colorFaded = color ? `${color}66` : 'var(--color-neutral-faded)'
  const colorSolid = color || 'var(--color-neutral)'

  return `
    ${backgroundColor} 
    linear-gradient(
      to right,
      ${colorFaded} ${elapsedTimePercent}%,
      ${colorSolid} ${elapsedTimePercent}%,
      ${colorSolid} calc(${elapsedTimePercent}% + 2px),
      transparent ${elapsedTimePercent}%`
}

export { getProgressBarBackground }
